import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";

import routes from "./routes";

import "bootstrap/dist/css/bootstrap.min.css";
import "./shards-dashboard/styles/shards-dashboards.1.1.0.min.css";
import { Dispatcher, Constants, Store } from "./flux";

import Login from "./views/Login";

const App = () => {

    const [ LoggedIn, SetLoggedIn ] = useState(false);

    useEffect(() => {

        const LocalLogin = localStorage.getItem("TMOB_LOGGEDIN");

        const checkUser = async () => {

            const DecryptedLoginDetails = await window.atob(localStorage.getItem("TMOB_LOGIN"));
            const LoginDetails = await JSON.parse(DecryptedLoginDetails);
            login(LoginDetails.user, LoginDetails.pass);
        }

        if (LocalLogin === "true") {

            if (localStorage.getItem("TMOB_LOGIN")) {

                checkUser();
            }
        }
    }, [])

    useEffect(() => {

        const getData = async () => {

            SetLoggedIn(true);
            Store.retrieveAreas();
            Store.retrieveApps();
        }

        if (LoggedIn) {

            getData();
        }

    }, [ LoggedIn ]);

    const login = async (Username, Password) => {

        const LoggedIn = await Store.loginUser(Username, Password);
        SetLoggedIn(LoggedIn);
    }

    if (LoggedIn) {
        return (
            <Router basename={process.env.REACT_APP_BASENAME || ""}>
                <div>
                    {routes.map((route, index) => {
                    return (
                        <Route
                        key={index}
                        path={route.path}
                        exact={route.exact}
                        component={props => {
                            return (
                            <route.layout {...props}>
                                <route.component {...props} />
                            </route.layout>
                            );
                        }}
                        />
                    );
                    })}
                </div>
            </Router>
        );
    } else {

        return (

            <Login LoginUser={ login } />
        );
    }
}

export default App;
